var swiper = new Swiper(".mySwiper", {
  grabCursor: true,
  centeredSlides: true,
  effect: "coverflow",
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 3,
    slideShadows: true,
  },

  /*
  keyboard: {
    enabled: true
  },
  mousewheel: {
    thresholdDelta: 70
  },
  */
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      effect: "slide",
      slidesPerView: 1, // ✅ Ensure only 1 slide on smaller screens
    },
    640: {
      slidesPerView: 3,
      initialSlide: 2,
    },
    768: {
      slidesPerView: 3,
      initialSlide: 2,
    },
    1024: {
      slidesPerView: 3,
      initialSlide: 2,
    },
    1560: {
      slidesPerView: 3,
      initialSlide: 2,
    },
  },
  on: {
    slideChange: function () {
      let slides = document.querySelectorAll(".mySwiper .swiper-slide video");

      // Pause all videos
      slides.forEach((video) => {
        if (!video.paused) {
          video.pause();
        }
      });
    },
    slideChangeTransitionEnd: function () {
      // Play video in active slide
      let activeSlide = document.querySelector(
        ".mySwiper .swiper-slide-active video"
      );
      if (activeSlide) {
        activeSlide.play();
      }
    },
  },
});


var swiperDesk = new Swiper(".promo_banner__content-desktop", {
  grabCursor: true,
  centeredSlides: true,
  effect: "coverflow",
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 3,
    slideShadows: true,
  },
 autoplay: {
   delay: 2000,
 },
  loop: true,
  breakpoints: {
    0: {
      effect: "slide",
      slidesPerView: 1, // ✅ Ensure only 1 slide on smaller screens
    },
    640: {
      slidesPerView: 1,
      initialSlide: 1,
    },
    768: {
      slidesPerView: 1,
      initialSlide: 1,
    },
    1024: {
      slidesPerView: 1,
      initialSlide: 1,
    },
    1560: {
      slidesPerView: 1,
      initialSlide: 1,
    },
  }
});

var swiperMobile = new Swiper(".promo_banner__content-mobile", {
  grabCursor: true,
  centeredSlides: true,
  effect: "coverflow",
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 3,
    slideShadows: true,
  },
 autoplay: {
   delay: 3000,
 },
  loop: true,
  breakpoints: {
    0: {
      effect: "slide",
      slidesPerView: 1, // ✅ Ensure only 1 slide on smaller screens
    },
    640: {
      slidesPerView: 1,
      initialSlide: 1,
    },
    768: {
      slidesPerView: 1,
      initialSlide: 1,
    },
    1024: {
      slidesPerView: 1,
      initialSlide: 1,
    },
    1560: {
      slidesPerView: 1,
      initialSlide: 1,
    },
  }
});
/*

var swiper = new Swiper(".mySwiper", {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "5",
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });
*/
$(".add-to-cart-external").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".product-form-prenatal").offset().top,
    },
    500
  ); // 500ms for smooth scroll
});
$(".play-button").click(function (e) {
  var video_id = $(this).data("id");
  var vid = $("#" + video_id).get(0);
  console.log("vid", vid);
  if (!vid) {
    console.error("Video not found.");
    return;
  }

  // Check if the video is loaded (readyState >= 2 means it's at least playable)
  if (vid.readyState < 2) {
    console.warn("Video is not fully loaded yet.");
    return;
  }

  if ($(this).hasClass("paused")) {
    $(vid).trigger("play");
    vid.play();
    $(this).addClass("play").removeClass("pause");
  } else {
    $(vid).trigger("pause");
    vid.pause();
    $(this).addClass("pause").removeClass("play");
  }
});

document.addEventListener("fullscreenchange", function (event) {
  if (document.fullscreenElement) {
    document.exitFullscreen();
  }
});

document.addEventListener("webkitfullscreenchange", function (event) {
  if (document.webkitFullscreenElement) {
    document.webkitExitFullscreen();
  }
});

$(".swatch-element").click(function () {
  setTimeout(function () {
    var selectedId = $(".v-option").val();

    $(".key-image.active").removeClass("active");
    var keyImage = $('.key-image[data-id="' + selectedId + '"]');
    if (keyImage.length) {
      keyImage.addClass("active");
    }

    $(".top-image.active").removeClass("active");
    var matchingImage = $('.top-image[data-id="' + selectedId + '"]');
    if (matchingImage.length) {
      matchingImage.addClass("active");
    }

    $(".top-heading.active").removeClass("active");
    var topTitle = $('.top-heading[data-id="' + selectedId + '"]');
    if (topTitle.length) {
      topTitle.addClass("active");
    }

    $(".subheading.active").removeClass("active");
    var topSubTitle = $('.subheading[data-id="' + selectedId + '"]');
    if (topSubTitle.length) {
      topSubTitle.addClass("active");
    }

    $(".top-icons.active").removeClass("active");
    var topIcon = $('.top-icons[data-id="' + selectedId + '"]');
    if (topIcon.length) {
      topIcon.addClass("active");
    }

    $(".center-image.active").removeClass("active");
    var centerImage = $('.center-image[data-id="' + selectedId + '"]');
    if (centerImage.length) {
      centerImage.addClass("active");
    }
    $(".right-image.active").removeClass("active");
    var rightImage = $('.right-image[data-id="' + selectedId + '"]');
    if (rightImage.length) {
      rightImage.addClass("active");
    }

    $(".right-content.active").removeClass("active");
    var rightContent = $('.right-content[data-id="' + selectedId + '"]');
    if (rightContent.length) {
      rightContent.addClass("active");
    }
    var bg = $(".bg-img[data-id='" + selectedId + "']").data("bg");
    var sec_id = $(".bg-img[data-id='" + selectedId + "']").data("section-id");
    $(sec_id).css("background-image", "url(" + bg + ")");
  }, 1000);
});
$("body").on("click touchstart", function () {
  const videoElements = document.getElementsByClassName("html-video-desktop");
  // const videoElementsMobile =
  //   document.getElementsByClassName("html-video-mobile");

  if (videoElements.length > 0) {
    const videoElement = videoElements[0]; // Get the first video element

    if (videoElement.paused) {
      videoElement.play();
    }
  }
  // if (videoElementsMobile.length > 0) {
  //   const videoElementMobile = videoElementsMobile[0]; // Get the first video element

  //   if (videoElementMobile.paused) {
  //     videoElementMobile.play();
  //   }
  // }

  const activeSlide = document.getElementsByClassName("swiper-slide-active");

  if (activeSlide.length > 0) {
    const videoElement1 = activeSlide[0].querySelector("video"); // Find the video inside active slide

    if (videoElement1 && videoElement1.paused) {
      videoElement1.play();
    }
  }
});

function removeVideo() {
  if ($(window).width() < 561) {
    $("#desktop-video").remove();
  }
}

// Run on page load
removeVideo();

// Run on window resize
$(window).resize(function () {
  removeVideo();
});

// $(".video-slide").on("click touchstart", function (event) {
//   event.preventDefault(); // Prevent unintended interactions
// });
// document.addEventListener(
//   "touchstart",
//   function (event) {
//     if (event.target.tagName === "VIDEO") {
//       event.preventDefault(); // Block fullscreen trigger
//     }
//   },
//   { passive: false }
// );

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("video").forEach((vid) => {
    vid.setAttribute("playsinline", "");
    vid.setAttribute("webkit-playsinline", "");
    vid.removeAttribute("fullscreen"); // Prevents fullscreen mode
  });
});
let lastScrollTop = 0; // Store the last scroll position

function myFunction(flag) {
  var MobDesk = document.querySelector(".header-section");
  var headerMobile = document.getElementById("header");
  var sticky = headerMobile.offsetTop;
  var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  if (window.pageYOffset > sticky && currentScroll < lastScrollTop) {
    MobDesk.classList.add("fixed-header-1");
  } else {
    MobDesk.classList.remove("fixed-header-1");
  }
  var headerDesk = document.querySelector(".header-section");
  var DeskHeader = document.getElementById("header-desktop");
  var stickyDesk = DeskHeader.offsetTop;
  if (window.pageYOffset > stickyDesk && currentScroll < lastScrollTop) {
    // if (window.pageYOffset > stickyDesk) {
    headerDesk.classList.add("fixed-header-1");
  } else {
    headerDesk.classList.remove("fixed-header-1");
  }
  if (window.pageYOffset == 0 && flag == true) {
    headerDesk.classList.remove("fixed-header-1");
  }
  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Prevent negative values
}
window.onscroll = function () {
  myFunction(true);
};

myFunction(false);
$(".mini_cart").click(function (e) {
  e.preventDefault();
  var p = $(this).parent();
  if ($(p).hasClass("active_link")) {
    $(p).removeClass("active_link");
  } else {
    $(p).addClass("active_link");
  }
});
setTimeout(function () {
  $(".sticky_nav .mini_cart").click(function (e) {
    e.preventDefault();
    var p = $(this).parent();
    $(p).toggleClass("active_link");
  });
}, 3000);

  // document.addEventListener("DOMContentLoaded", function () {
  //   const trigger = document.querySelector('a[data-dropdown-rel="search"]');
  //   const dropdown = document.querySelector('div[data-dropdown="search"]');
  //   let showTimer = null;

  //   trigger.addEventListener("mouseenter", () => {
  //     showTimer = setTimeout(() => {
  //       dropdown.setAttribute("style", "display: block !important;");
  //     }, 2000);
  //   });

  //   trigger.addEventListener("mouseleave", () => {
  //     clearTimeout(showTimer);
  //     hideDropdown();
  //   });

  //   dropdown.addEventListener("mouseleave", () => {
  //     hideDropdown();
  //   });

  //   function hideDropdown() {
  //     dropdown.setAttribute("style", "display: none !important;");
  //   }
  // });
